import React from 'react';
import * as theme from '../constants/theme';
import {Container} from '.';

const {BACKGROUND, TEXT_WHITE} = theme;

const Footer = () => (
	<footer>
		<Container>
			<div className='Footer-container'>
				<div className='Footer-item'>
					<strong>LP VENT AB</strong>
					<a href='tel:0709520154'>0709520154</a>
					<span>Maskinvägen 6</span>
					<span>523 38 ULRICEHAMN</span>
				</div>
				<div className='Footer-item right'>
					<a href='https://www.instagram.com/lpvent/'><img src='/static/instagram.png'/></a>
				</div>
			</div>
		</Container>
		<style jsx>
			{`
				footer {
					min-height: 100px;
					color: ${TEXT_WHITE};
					background-color: ${BACKGROUND};
				}

				.Footer-container {
					display: flex;
					flex-flow: column nowrap;
					align-items: center;
					height: 100%;
					width: 100%;
				}

				.Footer-item {
					padding: 20px;
					flex-grow: 1;
					display: flex;
					flex-flow: column nowrap;
					justify-content: center;
					text-align: center;
				}

				.Footer-item.right {
					flex-grow: 0;
					align-items: flex-end;
				}

				.Footer-item.right a {

				}

				.Footer-item span,
				.Footer-item strong,
				.Footer-item a {
					display: inline-block;
					color: ${TEXT_WHITE};
					padding: 10px;
					font-weight: normal;
				}

				.Footer-item img {
					max-width: 36px;
				}

				@media (min-width: 48em) {
					.Footer-container,
					.Footer-item {
						flex-flow: row nowrap;
					}

					.Footer-item {
						text-align: left;
						justify-content: flex-start;
					}
				}
			`}
		</style>
	</footer>
);

export default Footer;



// WEBPACK FOOTER //
// components/footer.js